(function(){
  function dots(){
    var wrap = document.querySelector('[id^="MainProduct-"] .product__media-wrapper');
    if(!wrap || wrap.dataset.b2bDots) return;
    var items = wrap.querySelectorAll('.product__media-list > .product__media-item');
    if(items.length < 2) return;
    wrap.dataset.b2bDots = '1';
    var box = document.createElement('div'); box.className = 'b2b-vdots';
    var inner = document.createElement('div'); inner.className = 'b2b-vdots__in';
    box.appendChild(inner);
    var list = [];
    Array.prototype.forEach.call(items, function(it, k){
      var d = document.createElement('button');
      d.type = 'button'; d.setAttribute('aria-label', 'Image ' + (k + 1));
      if(k === 0) d.className = 'on';
      d.addEventListener('click', function(){ it.scrollIntoView({behavior: 'smooth', block: 'start'}); });
      inner.appendChild(d); list.push(d);
    });
    wrap.insertBefore(box, wrap.firstChild);
    var tick = false;
    function upd(){
      tick = false;
      var mid = window.innerHeight / 2, best = 0, bd = Infinity;
      Array.prototype.forEach.call(items, function(it, k){
        var r = it.getBoundingClientRect();
        if(!r.height) return;
        var dd = Math.abs((r.top + r.bottom) / 2 - mid);
        if(dd < bd){ bd = dd; best = k; }
      });
      list.forEach(function(d, k){ d.className = (k === best) ? 'on' : ''; });
    }
    window.addEventListener('scroll', function(){ if(!tick){ tick = true; window.requestAnimationFrame(upd); } }, {passive: true});
    upd();
  }
  /* Massimo Castelli 21.10.2026: a visitor who comes from "Ready to ship" (or a "... - Stock available" collection)
     sees only the colours that are in stock. Links keep ?ready=1 so the rule stays while switching colours. */
  function readyMode(){
    try{
      if(/[?&]ready=1(&|$)/.test(location.search)) return true;
      var ref = document.referrer || '';
      if(ref && ref.indexOf(location.host) > -1 && /\/collections\/(ready-to-ship|[a-z0-9-]+-ready)(\/|\?|#|$)/.test(ref)) return true;
    }catch(e){}
    return false;
  }
  function readySet(root){
    return fetch(root + 'collections/ready-to-ship/products.json?limit=250')
      .then(function(r){ return r.json(); })
      .then(function(j){ var s = {}; (j.products || []).forEach(function(p){ s[p.handle] = 1; }); return s; });
  }
  function colours(){
    var box = document.querySelector('.b2b-colours');
    if(!box || box.dataset.done) return;
    box.dataset.done = '1';
    var model = box.getAttribute('data-model');
    var cur = box.getAttribute('data-handle');
    var list = box.querySelector('.b2b-colours__list');
    if(!model || !list) return;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var ready = readyMode();
    var only = ready ? readySet(root).catch(function(){ return null; }) : Promise.resolve(null);
    var search = fetch(root + 'search/suggest.json?q=' + encodeURIComponent(model) + '&resources[type]=product&resources[limit]=10&resources[options][fields]=title')
      .then(function(r){ return r.json(); });
    Promise.all([search, only]).then(function(res){
        var j = res[0], set = res[1];
        var ps = (j.resources && j.resources.results && j.resources.results.products) || [];
        ps.forEach(function(p){
          if(!p.title || p.title.indexOf(model + ' - ') !== 0) return;
          if(p.handle === cur) return;
          if(set && !set[p.handle]) return;
          var src = p.featured_image && p.featured_image.url;
          if(!src) return;
          var name = p.title.slice(model.length + 3);
          var a = document.createElement('a');
          a.className = 'b2b-colours__item';
          a.href = String(p.url).split('?')[0] + (set ? '?ready=1' : '');
          a.title = name;
          var im = document.createElement('img');
          im.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=160';
          im.alt = name; im.loading = 'lazy';
          a.appendChild(im); list.appendChild(a);
        });
      }).catch(function(){});
  }
  function run(){ dots(); colours(); }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
